import React from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';

const Title = styled.h1<StyledProps>`
  font-size: ${props => props.variant === 'default' ? props.theme.fontSize.title : props.theme.fontSize.smallTitle}px;
  font-family: ${props => props.theme.fontFamily};
  line-height: 1.31;
  text-align: ${props => props.align};
  font-weight:  ${props => props.fontWeight ? props.fontWeight : 'normal'};
  font-stretch: normal;
  font-style: normal;
  color: ${props => props.color ? props.color : props.theme.colors.grey[300]};
  opacity: ${props => props.disabled ? .3 : 1 };
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  letter-spacing: -0.1px;
  @media screen and (min-width: 768px) {
    font-size: ${props => props.variant === 'default' ? props.theme.fontSizeTablet.title : props.theme.fontSizeTablet.smallTitle}px;
    margin: ${props => props.marginTablet ? (props.marginTablet === 'number' ? `${props.marginTablet}px` : props.marginTablet) : props.margin}; 
  }
`
const SubTitle = styled.h2<StyledProps>`
  font-size: ${props => props.theme.fontSize.subtitle}px;
  font-family: ${props => props.theme.fontFamily};
  line-height: 1.42;
  text-align: ${props => props.align};
  font-weight:  ${props => props.fontWeight ? props.fontWeight : '600'};
  font-stretch: normal;
  font-style: normal;
  color: ${props => props.color ? props.color : props.theme.colors.grey[300]};
  opacity: ${props => props.disabled ? .3 : 1 };
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  letter-spacing: -0.1px;
  @media screen and (min-width: 768px) {
    font-size: ${props => props.theme.fontSizeTablet.subtitle}px;
    margin: ${props => props.marginTablet ? (props.marginTablet === 'number' ? `${props.marginTablet}px` : props.marginTablet) : props.margin}; 
  }
`

const Label = styled.h3<StyledProps>`
  font-size: ${props => props.theme.fontSize.label}px;
  font-family: ${props => props.theme.fontFamily};
  line-height: 1.4;
  text-align: ${props => props.align};
  font-weight:  ${props => props.fontWeight ? props.fontWeight : 'normal'};
  font-stretch: normal;
  font-style: normal;
  color: ${props => props.color ? props.color : props.theme.colors.grey[300]};
  opacity: ${props => props.disabled ? .3 : 1 };
  letter-spacing: 0.1px;
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  letter-spacing: -0.1px;
  @media screen and (min-width: 768px) {
    margin: ${props => props.marginTablet ? (props.marginTablet === 'number' ? `${props.marginTablet}px` : props.marginTablet) : props.margin}; 
  }
`


const Description = styled.h4<StyledProps>`
  font-size: ${props => props.theme.fontSize.description}px;
  font-family: ${props => props.theme.fontFamily};
  line-height: 1.4;
  text-align: ${props => props.align};
  font-weight:  ${props => props.fontWeight ? props.fontWeight : 'normal'};
  font-stretch: normal;
  font-style: normal;
  color: ${props => props.color ? props.color : props.theme.colors.grey[500]};
  opacity: ${props => props.disabled ? .3 : 1 };
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
  letter-spacing: -0.1px;
  @media screen and (min-width: 768px) {
    margin: ${props => props.marginTablet ? (props.marginTablet === 'number' ? `${props.marginTablet}px` : props.marginTablet) : props.margin}; 
  }
`

interface StyledProps {
  theme: ITheme,
  color?: string | undefined;
  align: 'center' | 'left' | 'right';
  disabled: boolean;
  fontWeight?: string | number | undefined;
  margin: string | number;
  marginTablet?: string | number;
  variant: string;
}
export interface HeadingProps {
  variant: 'default' | 'sub' | 'label' | 'inline' | 'desc' | 'smallTitle';
  children?: React.ReactNode;
  theme?: ITheme;
  align: 'center' | 'left' | 'right';
  color?: string | undefined;
  disabled: boolean;
  fontWeight?: string | number | undefined;
  margin: string | number;
  marginTablet?: string | number;
}

function Heading({ variant, children, align, color, disabled, fontWeight, margin, marginTablet }: HeadingProps) {
  const theme = useTheme();
  switch(variant) {
    case 'sub':
      return <SubTitle variant={variant} theme={theme} align={align} color={color} margin={margin} disabled={disabled} marginTablet={marginTablet} fontWeight={fontWeight}>{children} </SubTitle>
    case 'label':
      return <Label variant={variant} theme={theme} align={align} color={color} margin={margin} disabled={disabled}  marginTablet={marginTablet} fontWeight={fontWeight}>{children}</Label>
    case 'desc':
      return <Description variant={variant} theme={theme} align={align} color={color} margin={margin} disabled={disabled} marginTablet={marginTablet} fontWeight={fontWeight}>{children}</Description>
    case 'default':
    default:
      return <Title variant={variant} theme={theme} align={align} color={color} disabled={disabled} margin={margin} marginTablet={marginTablet} fontWeight={fontWeight}>{children}</Title>

  }
};

Heading.defaultProps = {
  variant: 'default',
  align: 'left',
  color: undefined,
  disabled: false,
  margin: '0 0 15px'
}

export default Heading;
